import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { callNotification } from "../../redux/constants";
import isEqual from "react-fast-compare";
import { PlusCircleFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
import ColorPicker from "../../components/commandCenter/components/ScreenHeader/CustomColorPicker";
import {
  setCustomPaletteInfo,
  togglePersonalisation,
} from "../../redux/actions/DIYPersonalization/PersonalizationSettings";

const AccentColors = ({
  paletteIndex,
  accentColorList,
  isColorPickerDisabled,
}) => {
  const dispatch = useDispatch();
  const PersonalizationSettingObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const PersonalizationSettingState = useSelector(
    (state) => state?.PersonalizationSetting
  );

  // Check if current screen is Network screen (000-000-560 or 000-000-563)
  const isNetworkScreen = ["000-000-560", "000-000-563"].includes(
    PersonalizationSettingState?.PreviewScreenId
  );

  // State for accent colors
  const [accentColors, setAccentColors] = useState(() => accentColorList || []);

  useEffect(() => {
    setAccentColors(accentColorList || []);
  }, [accentColorList]);

  // any update to accentColors (local state) will be dispatched to personalisation state
  useEffect(() => {
    setTimeout(() => {
      dispatch(
        setCustomPaletteInfo(paletteIndex, "AccentColors", accentColors)
      );
      dispatch(
        togglePersonalisation(!PersonalizationSettingObj?.togglePersonalisation)
      );
    }, 200);
  }, [accentColors]);

  // function to add accent colors
  const handleAddAccentColor = () => {
    if (isColorPickerDisabled || isNetworkScreen) return;
    // limit of 10
    if (accentColors?.length < 10) {
      setAccentColors((accentColors) => [...accentColors, ""]);
    } else {
      callNotification(
        "Cannot add more than 10 data colors",
        "error",
        40,
        "personalization-preview-notification personalization-preview-mask",
        true
      );
    }
  };

  // function to delete accent colors
  const handleDeleteAccentColor = (index) => {
    if (isNetworkScreen) return;
    // Remove color at the specified index
    if (accentColors?.length > 4) {
      setAccentColors((accentColors) => [
        ...accentColors.slice(0, index),
        ...accentColors.slice(index + 1),
      ]);
    }
  };

  // this function is passed to color picker, updates hex code to accentColors array
  const handleUpdateAccentColorList = (updatedAccentArray) => {
    if (isNetworkScreen) return;
    setAccentColors(updatedAccentArray);
  };
  // Wrapper component for disabled state with tooltip
  const AccentColorsContent = () => (
    <div>
      <div
        style={{ justifyContent: "space-between" }}
        className=" d-flex  Setting__LabelFont--2 Setting__TextColor--1 Setting__LabelFontWeight--500 mt-2"
      >
        <span>
          {" "}
          Widget data{" "}
          <Tooltip
            title={
              <div className="d-flex align-items-center">
                Kindly use color picker to choose data colors
              </div>
            }
          >
            {" "}
            <i
              className="fa fa-info-circle cursor-pointer ml-1"
              style={{ fontSize: "1.7rem" }}
            />
          </Tooltip>
        </span>

        <Tooltip title={"Add new data color"}>
          <PlusCircleFilled
            style={{ fontSize: "20px" }}
            onClick={handleAddAccentColor}
            className={isColorPickerDisabled ? "disabled-cursor" : ""}
          />
        </Tooltip>
      </div>

      <div className="ControlSelector__Row mb-2">
        {Array.isArray(accentColors) ? (
          <>
            {accentColors.map((Accent, index) => (
              <div
                className="ControlSelector__Row--item"
                key={`AccentControlSelector__Row--item${Accent}-${index}`}
              >
                <div className="d-flex flex-direction-column">
                  <span className="Setting__LabelFont--3 Setting__TextColor--2 Setting__LabelFontWeight--500 mb-1">
                    {`Data Points/Charts ${index + 1}`}
                  </span>
                  <ColorPicker
                    accentLocalList={accentColors}
                    defaultValue={accentColors?.[index] ?? "add color"}
                    configType={`AccentColor${index}`}
                    keyComponent={`CommandCenterSelectedAccentColor`}
                    index={`${paletteIndex}-${index}`}
                    onDelete={() => handleDeleteAccentColor(index)} // delete button is in color picker component
                    updateAccentList={(updatedAccentArray) =>
                      handleUpdateAccentColorList(updatedAccentArray)
                    }
                    isColorPickerDisabled={isColorPickerDisabled}
                  />
                </div>
              </div>
            ))}
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );

  return (
    <>
      {isNetworkScreen && !isColorPickerDisabled ? (
        <Tooltip
          title="This setting is directly available through screen settings"
          placement="top"
        >
          <div>
            <div className="disable">
              <AccentColorsContent />
            </div>
          </div>
        </Tooltip>
      ) : (
        <AccentColorsContent />
      )}
    </>
  );
};

export default React.memo(AccentColors, isEqual);
